query hasChildCompany {
  hasChildCompany: hasChildCompany
}
